import React from "react";
import PdfLayout from '../PdfLayout';
import PdfLayoutWidget from './PdfLayoutWidget';
import { Screen } from '../../services';
import i18n from '../../locales/i18n';
import { isThermalPdfLayout } from '../../services/pdfLayoutCanvasPreviewUtils';

import armsColor from '../../assets/images/lausanne-arms-color.png';
import armsMono from '../../assets/images/lausanne-arms-mono.png';

/** Class representing the Lausanne coat of arms PDF widget. */
class LausanneArmsWidget extends PdfLayoutWidget {

    constructor(properties) {
        super({
            ...(LausanneArmsWidget.getDefaultOptions()),
            ...properties,
            type: PdfLayout.IMAGE,
            subType: PdfLayout.LAUSANNE_ARMS
        });
    }

    /**
     * Get this widget default options
     */
    static getDefaultOptions() {
        return {
            position: { x: 2, y: 2, z: 0 },
            dimensions : { width: 4, height: 2.5 },
            transform: { rotation: 0 },
            options: {
                variant: PdfLayout.LAUSANNE_ARMS_VARIANT_COLOR,
                lockRatio: true,
                style: {
                    align: 'center',
                    objectFit: "contain",
                    borderStyle: 'solid',
                    borderWidth: 0,
                    borderColor: '#000000',
                    borderRadius: 0,
                    padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                    }
                },
            }
        };
    }

    /**
     * Return the list of options this widget handles
     */
    getHandledOptions() {
        return super.getHandledOptions().concat([
            PdfLayout.OPTION_OBJECT_FIT,
            PdfLayout.OPTION_ALIGNMENT,
            PdfLayout.OPTION_PADDING,
            PdfLayout.OPTION_LAUSANNE_ARMS_VARIANT,
        ]);
    }

    getPreviewSrc(props) {
        if (isThermalPdfLayout(props.layoutTarget) || this.options?.variant === PdfLayout.LAUSANNE_ARMS_VARIANT_MONO)
            return armsMono;

        return armsColor;
    }

    /**
     * Return this widget preview as JSX string
     *
     * @param {Object} props with at least the following properties:
     *                 - {Bool} inEdition
     *                 - {String} lang
     *                 - {Object} setting
     */
    getPreview(props) {
        const { inEdition } = props;
        let imageStyle = {};
        if (this.options.style?.objectFit === 'cover' || this.options.style?.objectFit === 'contain') {
            imageStyle = {
                width: '100%',
                height: '100%',
                objectFit: this.options.style?.objectFit
            };
        } else {
            imageStyle = {
                width: '100%',
                height: '100%',
            };
        }

        return (
            <>
                <img
                    ref={props.ref}
                    src={this.getPreviewSrc(props)}
                    alt={i18n.t('layouts.image_lausanne_arms')}
                    style={{
                        ...imageStyle,
                        width: Screen.cmToPx(this.dimensions?.width) - (inEdition ? 2 : 0),
                        height: Screen.cmToPx(this.dimensions?.height) - (inEdition ? 2 : 0),
                    }}
                />
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0
                }} />
            </>
        );
    }

    /**
     * Return the icon to use on the editor button
     */
    getIcon() {
        return 'flag';
    }
}

export default LausanneArmsWidget;
